import React from 'react';
import runRouteImg from '../../assets/images/RunRoute.png';


const RaceDay: React.FC = () => (
  <div className="race-day-page" style={{ maxWidth: 800, margin: '0 auto', padding: 20 }}>
    <div>
      <p>
        <strong>Race Day Registration</strong> 7:30 - 8:50 am @ Stoddard Park
      </p>
      <p>
        <strong>Start time</strong> for both the Triathlon &amp; 5K is <strong>9:00 am SHARP</strong>
      </p>
      <p>
        <strong>The Routes:</strong>
        <br />
        Canoe route is twice around Lake Martha<br />
        Running route: Triathlon &amp; 5K
      </p>
    </div>
    <img
      src={runRouteImg}
      alt="Race Route Map"
      style={{ width: '100%', marginTop: 16, border: '1px solid #ccc' }}
    />
  </div>
);

export default RaceDay;